import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { publish, refCount } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	private _maxAge = null;
	set expire(value) {
		this._maxAge = value;
	}

	notificationTimer;
	private _notification: BehaviorSubject<string> = new BehaviorSubject(null);
	readonly notification$: Observable<string> = this._notification.asObservable().pipe(
		publish(),
		refCount()
	);

	constructor() { }

	notify(message) {
		// console.log(message, this.notificationTimer);
		this._notification.next(message);

		if (this.notificationTimer) {
			clearTimeout(this.notificationTimer);
		}
		if (!([null, undefined, ''].includes(this._maxAge))) {
			this.notificationTimer = setTimeout(() => this._notification.next(null), this._maxAge);
		}
	}

	clear() {
		this._notification.next(null);
	}
}
